import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import MutasiDetailNoQrTab from "./mutasiDetailQR/mutasiDetailNoQrTab";
import MutasiDetailQrTab from "./mutasiDetailQR/mutasiDetailQrTab"

class MutasiPartDetailTabs extends Component {
  render() {
    return (
      <Tabs>
        <TabList>
          <Tab>Tanpa QR</Tab>
          <Tab>Dengan QR</Tab>
        </TabList>
        <TabPanel>
          <MutasiDetailNoQrTab
            state={this.props.state}
            buttonType={this.props.buttonType}
            onSetState={this.props.onSetState}
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
        <TabPanel>
          <MutasiDetailQrTab
            state={this.props.state}
            buttonType={this.props.buttonType}
            onSetState={this.props.onSetState}
            tab="barangLain"
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
      </Tabs>
    );
  }
}

export default MutasiPartDetailTabs;
